import ApiService from './ApiService';

class BackgroundService {
  constructor() {
    this._blobUrls = []; // Merke alle Blob-URLs für späteres Revoken
  }

  _revokeBlobUrls() {
    this._blobUrls.forEach(url => URL.revokeObjectURL(url));
    this._blobUrls = [];
  }

  // Lade alle verfügbaren Farben
  async getColors() {
    try {
      console.log('🌈 BackgroundService.getColors: GET /bg/ ...');
      const colors = await ApiService.get('/bg/');
      console.log('🌈 BackgroundService.getColors: Rohantwort:', colors);
      console.log('🌈 BackgroundService.getColors: Typ:', typeof colors, Array.isArray(colors) ? `Array[${colors.length}]` : '');

      // Normalisiere auf Array, egal was das Backend zurückgibt
      let colorList;
      if (Array.isArray(colors)) {
        colorList = colors;
      } else if (typeof colors === 'string') {
        // z.B. "blau\ngrün\nrot" oder "blau,grün,rot"
        colorList = colors.split(/[\n,]+/).map(s => s.trim()).filter(Boolean);
        console.log('🌈 getColors: String zu Array geparst:', colorList);
      } else if (colors && typeof colors === 'object') {
        // z.B. { colors: [...] } oder { data: [...] }
        colorList = colors.colors ?? colors.data ?? colors.items ?? Object.values(colors);
        if (!Array.isArray(colorList)) colorList = [];
        console.log('🌈 getColors: Objekt zu Array extrahiert:', colorList);
      } else {
        console.warn('🌈 getColors: unbekanntes Format, gebe leer zurück:', colors);
        return [];
      }

      const result = await Promise.all(
        colorList.map(async (color) => {
          let mainImageUrl;
          try {
            mainImageUrl = await ApiService.fetchBlobUrl(`/bg/${color}`);
            this._blobUrls.push(mainImageUrl);
            console.log(`🌈 getColors: Blob-URL für "${color}" geladen`);
          } catch (e) {
            console.warn(`🌈 getColors: fetchBlobUrl für "${color}" fehlgeschlagen, nutze direkte URL:`, e.message);
            mainImageUrl = ApiService.getImageUrl(`/bg/${color}`);
          }
          return {
            id: color,
            name: color.charAt(0).toUpperCase() + color.slice(1),
            mainImageUrl,
          };
        })
      );
      console.log('🌈 BackgroundService.getColors: fertig, gibt zurück:', result);
      return result;
    } catch (error) {
      console.error('🌈 BackgroundService.getColors: Fehler:', error);
      return [];
    }
  }

  // Lade alle Varianten einer bestimmten Farbe
  async getVariants(color) {
    try {
      const raw = await ApiService.get(`/bg/${color}/variants`);
      console.log(`🌈 getVariants(${color}): Rohantwort:`, raw);

      let variants;
      if (Array.isArray(raw)) {
        variants = raw;
      } else if (typeof raw === 'string') {
        variants = raw.split(/[\n,]+/).map(s => s.trim()).filter(Boolean);
      } else if (raw && typeof raw === 'object') {
        variants = raw.variants ?? raw.data ?? raw.items ?? Object.values(raw);
        if (!Array.isArray(variants)) variants = [];
      } else {
        console.warn(`🌈 getVariants(${color}): unbekanntes Format:`, raw);
        return [];
      }

      const result = await Promise.all(
        variants.map(async (variant) => {
          let imageUrl;
          try {
            imageUrl = await ApiService.fetchBlobUrl(`/bg/${color}/variants/${variant}`);
            this._blobUrls.push(imageUrl);
          } catch {
            imageUrl = ApiService.getImageUrl(`/bg/${color}/variants/${variant}`);
          }
          return {
            id: `${color}-${variant}`,
            color,
            variant,
            name: `${color.charAt(0).toUpperCase() + color.slice(1)} Variante ${variant}`,
            imageUrl,
            path: `${color}/${variant}`,
          };
        })
      );
      return result;
    } catch (error) {
      console.error(`Fehler beim Laden der Varianten für ${color}:`, error);
      return [];
    }
  }

  // Lade alle verfügbaren Hintergründe (Legacy-Kompatibilität)
  async getBackgrounds() {
    try {
      const colors = await this.getColors();
      const allBackgrounds = [];

      for (const color of colors) {
        const variants = await this.getVariants(color.id);
        allBackgrounds.push(...variants);
      }

      return allBackgrounds;
    } catch (error) {
      console.error('Fehler beim Laden der Hintergründe:', error);

      // Fallback zu statischen Optionen
      return [
        {
          id: 'bg1',
          name: 'Natur Grün',
          color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          fallback: true
        },
        {
          id: 'bg2',
          name: 'Sonnenuntergang',
          color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          fallback: true
        }
      ];
    }
  }

  // Hole spezifischen Hintergrund
  getBackgroundUrl(filename) {
    return ApiService.getImageUrl(`/bg/${filename}`);
  }
}

export default new BackgroundService();
